





















































































































































































































































































import { Vue, Component, Prop, p, Lifecycle } from "av-ts";
import { ILink, IUser, IOffering, IOfferingUser } from "./interfaces/models";
import { isAdmin } from "./util";
import LinkManager from "./routes/links";

// Special case where main.vue needs to refresh application
import UserRepository from "./repositories/UserRepository";
import UserService from "./services/UserService";
import Fetcher from "./services/Fetcher";

import UserContainer from "./components/UserContainer.vue";
import PageLoader from "./components/util/PageLoader.vue";
import GlobalNotification from "./GlobalNotification.vue";

import ApplicationService from "./services/ApplicationService";


@Component({
    components: {
        GlobalNotification,
        UserContainer,
        PageLoader
    }
})
export default class Main extends Vue {
    @Prop path = p<string>({
        required: true
    });

    @Prop demoAdmin = p<boolean>({
        default: false
    });

    @Prop demoStudent = p<boolean>({
        default: false
    });

    offeringRoles: string[] = [];
    pUser: IUser | undefined = undefined;
    pOffering: IOffering | undefined = undefined;
    linkManager: LinkManager = new LinkManager();
    pMenuLinks: ILink[] = this.linkManager.getLinks();
    pOfferingUser: IOfferingUser | undefined = undefined;
    currentlyOpenMenu: ILink | undefined = undefined;

    menuIcon = "menu";
    closeIcon = "close";
    sideMenuIsOpen = false;
    mobileMode = false;
    pageTitle = "";
    activeSubmenu = false;
    loading = false;

    get user() {
        return this.pUser;
    }

    updateUser(newUser: IUser | undefined) {
        this.pUser = newUser;
    }

    updateOfferingUser(offeringUser: IOfferingUser) {
        if (JSON.stringify(this.pOfferingUser) == JSON.stringify(offeringUser)) {
            return;
        }
        this.updateUser(offeringUser.user);
        this.offeringRoles = offeringUser.roles;
        this.pOfferingUser = offeringUser;

        if (this.pOffering === undefined) {
            this.pOffering = offeringUser.offering;
        }

        this.pMenuLinks = this.linkManager.resetLinks();
        const adminLinkIndex = this.pMenuLinks.findIndex(x => x.text == "Admin");
        const profileLinkIndex = this.pMenuLinks.findIndex(x => x.text == "Profile");
        // Fix links
        if (this.offering !== undefined && isAdmin(offeringUser.roles)) {
            if (profileLinkIndex >= 0) {
                this.pMenuLinks.splice(profileLinkIndex, 1);
            }
            // Only redirect when no menu is open
            this.currentlyOpenMenu = this.pMenuLinks[0];
            this.$router.push("/admin");
        } else {
            const profilesLinkIndex = this.pMenuLinks.findIndex(x => x.text == "Profiles");
            if (profilesLinkIndex >= 0) {
                this.pMenuLinks.splice(profilesLinkIndex, 1);
            }
            if (adminLinkIndex >= 0) {
                this.pMenuLinks.splice(adminLinkIndex, 1);
                const questionLinkIndex = this.pMenuLinks.findIndex(x => x.text == "Questions");
                if (questionLinkIndex == -1) {
                    throw new Error("Missing question links.");
                }
                this.currentlyOpenMenu = this.pMenuLinks[questionLinkIndex].submenu![0];
            }
        }
    };

    get links() {
        return this.pMenuLinks;
    }

    get pageSize() {
        return {
            "mobilePage": this.mobileMode,
            "largePage": !this.mobileMode,
            "expanded": this.sideMenuIsOpen
        };
    }
    get menuButtonClass() {
        return {
            "highlighted": this.sideMenuIsOpen
        };
    }

    get offeringUser() {
        return this.pOfferingUser;
    }

    set offeringUser(newUser: IOfferingUser | undefined) {
        this.pOfferingUser = newUser;
    }

    resized() {
        const sideNav = (this.$refs.sidenavContainer as Vue);
        const visible = (this.$refs.isVisible as Vue);
        if (!sideNav || !visible) {
            return;
        }

        const container = sideNav.$el;
        const isVisible = visible.$el;
        if (window.getComputedStyle(isVisible).display !== "none") {
            this.mobileMode = true;
            ApplicationService.setMobileMode(true);
            container.style.transform = null;
        } else {
            this.mobileMode = false;
            ApplicationService.setMobileMode(false);
            container.style.transform = "translate3d(0,0,0)";
        }
    }

    updatePageName() {
        if (this.currentlyOpenMenu !== undefined) {
            if (this.currentlyOpenMenu.href != "") {
                this.pageTitle = this.currentlyOpenMenu.text;
            } else if (this.currentlyOpenMenu.href == "" && this.path !== undefined) {
                this.pageTitle = this.path.charAt(0).toUpperCase() + this.path.slice(1);
            }
        }
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateOfferingUser);
    }

    @Lifecycle
    mounted() {
        window.addEventListener("resize", this.resized);
        this.updatePageName();
        this.resized();
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateOfferingUser);

        window.removeEventListener("resize", this.resized);
    }

    get offering() {
        return this.pOffering;
    }

    updateOffering(newOffering: IOffering) {
        if (newOffering === undefined) return;

        this.pOffering = newOffering;
        this.loading = true;
        UserRepository.authenticate(newOffering.offeringID)
            .then(consented =>
                UserService.getLoggedInUser()
                    .then(newUser =>
                        [consented, newUser]))
            .then(this.changeUser.bind(null));
    }

    changeUser(data: [boolean, IOfferingUser]) {
        Fetcher.forceUpdate().then(this.stopLoading.bind(null));
        this.updateOfferingUser(data[1]);
        if (data[0]) {
            if (isAdmin(data[1].roles)) {
                this.$router.push("/admin");
            } else {
                this.$router.push("/question/answer");
            }
        } else {
            this.$router.push("/profile/consent");
        }
    }

    stopLoading() {
        this.loading = false;
    }

    toggleSubmenu(link: ILink) {
        this.currentlyOpenMenu = link;
        this.updatePageName();
    }

    toggleSideNav(link: ILink | undefined) {
        if (link !== undefined) {
            this.toggleSubmenu(link);
        }

        if (this.mobileMode) {
            this.updatePageName();
            const linkHasSubmenu = link !== undefined && link.submenu !== undefined;
            if (this.sideMenuIsOpen && linkHasSubmenu) {
                this.sideMenuIsOpen = true;
            } else if (this.sideMenuIsOpen && !linkHasSubmenu) {
                this.sideMenuIsOpen = false;
            } else {
                this.sideMenuIsOpen = true;
            }
        }
    }

    keepProfileActive(link: ILink) {
        this.activeSubmenu = true;
        this.toggleSideNav(link);
        if (this.mobileMode) {
            const container = (this.$refs.sidenavContainer as Vue).$el;
            container.style.transform = null;
            this.menuIcon = "menu";
        }
    }

    submenuClassNames(link: ILink) {
        if (link.submenu !== undefined) {
            return "has-submenu";
        }
    }

    hideSideBar() {
        this.sideMenuIsOpen = false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Main.vue